import { PageContainer } from '../components/layout/PageContainer'

export default function AboutPage() {
  return (
    <div>
      {/* Hero */}
      <div className="bg-gcg-dark text-white py-16 border-b-[3px] border-primary">
        <PageContainer>
          <h1 className="text-3xl sm:text-4xl font-bold mb-3">Over Global Control Group</h1>
          <p className="text-white/80 text-lg max-w-2xl">
            Het enige bedrijf in Nederland dat B&amp;R Value Provider en technisch distributeur combineert.
          </p>
        </PageContainer>
      </div>

      <PageContainer className="py-12">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
          {/* Main content */}
          <div className="lg:col-span-2 flex flex-col gap-6 text-sm text-neutral-700 leading-relaxed">
            <div>
              <h2 className="text-xl font-bold text-neutral-900 mb-3">Wie zijn wij</h2>
              <p>
                Global Control Group B.V. is een gespecialiseerd automatiseringsbedrijf gevestigd in Volendam. Wij zijn erkend B&amp;R industrieel automatiseringsdistributeur én gecertificeerd B&amp;R Value Provider.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-neutral-900 mb-3">Onze positie</h2>
              <p className="mb-3">
                Wij zijn het enige bedrijf in Nederland dat tegelijkertijd de B&amp;R distributielicentie en de B&amp;R Value Provider-certificering bezit. Dat betekent voor onze klanten:
              </p>
              <ul className="flex flex-col gap-2 ml-4">
                {[
                  'Directe toegang tot het volledige B&R productportfolio tegen concurrerende prijzen',
                  'Engineering in eigen huis voor schakelkasten, software en inbedrijfstelling',
                  'Officiële B&R trainingen en certificeringen lokaal beschikbaar',
                  'Eén aanspreekpunt: hardware én engineering van één vertrouwde partner',
                ].map(item => (
                  <li key={item} className="flex items-start gap-2">
                    <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-primary shrink-0" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-bold text-neutral-900 mb-3">Onze expertise</h2>
              <p>
                Ons engineeringteam heeft ruime ervaring in industriële automatisering, PLC-programmering, motion control en machinebeveiliging. Wij bedienen OEM's, systeemintegratoren en eindgebruikers door heel Nederland en de bredere EU-markt.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-bold text-neutral-900 mb-3">Contact</h2>
              <div className="flex flex-col gap-1 text-neutral-600">
                <p>Global Control Group B.V.</p>
                <p>Julianaweg 200, Volendam</p>
                <p>
                  <a href="tel:+31299705078" className="text-primary hover:underline">
                    T: +31 299 705 078
                  </a>
                </p>
                <p>
                  <a href="mailto:info@globalcontrol.group" className="text-primary hover:underline">
                    info@globalcontrol.group
                  </a>
                </p>
              </div>
            </div>
          </div>

          {/* Sidebar */}
          <div className="flex flex-col gap-4">
            <div className="rounded-xl border border-neutral-200 bg-neutral-50 p-5">
              <h3 className="font-semibold text-sm text-neutral-700 mb-3">In het kort</h3>
              <dl className="flex flex-col gap-2 text-sm">
                {[
                  { label: 'Opgericht', value: '2024' },
                  { label: 'Locatie', value: 'Volendam, Nederland' },
                  { label: 'Specialisatie', value: 'B&R Industriële Automatisering' },
                  { label: 'Status', value: 'B&R Value Provider' },
                  { label: 'Distributie', value: 'Officieel NL Distributeur' },
                ].map(row => (
                  <div key={row.label} className="flex justify-between gap-2">
                    <dt className="text-neutral-500">{row.label}</dt>
                    <dd className="font-medium text-neutral-900 text-right">{row.value}</dd>
                  </div>
                ))}
              </dl>
            </div>
          </div>
        </div>
      </PageContainer>
    </div>
  )
}
